<template>
  <span :class="[
    errorType ? ['msg', 'icon'] : '',
    !val || val === '0'
      ? getErrorTypeStyle()
      : ($parent.showToggle ? 'valid hide' : 'valid show'),
    ]">
    <div class="icon" v-if="errorType">
      <awesomeIcon :icon="getErrorTypeIcon()" />
    </div>
    <template v-if="val">
      <template v-if="validtext">{{validtext}}</template>
      <template v-else>{{inputBasedOnType()}}</template>
    </template>
    <template v-else-if="errorKey && errorType !== 'blocker'">
      {{fallback}}
      <button
        @click="
          overwritable
          = !overwritable
        "
        class="no-padding"
        style="float:right;"
      >
        <awesomeIcon
          :icon="overwritten ? 'check' : 'handshake'"
        />
        <span class="mobile-hidden">
          {{overwritten ? 'Overschreven' : 'Overschrijven'}}
        </span>
      </button>
      <form @submit.prevent v-if="overwritable">
        <textarea
          v-model="overwritableReason"
          style="margin-top: 10px;"
          @keyup="setOverwrite"
        />
      </form>
      <template v-if="overwritten">
        <br />
        {{
          overwritableDate ? `Status gezet op ${new Date(overwritableDate).toLocaleString()} door
          ${overwritableUser}.` : ''
        }}
      </template>
    </template>
    <template v-else>
      {{fallback}}
    </template>
  </span>
</template>

<script>
export default {
  name: 'ValueChecker',
  props: {
    val: null,
    errorType: null,
    errorKey: null,
    fallback: String,
    validtext: String,
    type: String,
  },
  data() {
    return {
      overwritable: false,
      overwritableReason: '',
      overwritten: false,
      overwritableDate: '',
      overwritableUser: '',
    };
  },
  created() {
    // eslint-disable-next-line
    this.$store.state.overview[this.$.uid] = (!this.val || this.val == 0) ? false : true;
    if ((!this.val || this.val === '0') && !this.errorKey) {
      this.$store.state.errors[this.$.uid] = this.fallback;
    }
  },
  mounted() {
    if (this.$store.state.showstoppers[this.errorKey]) {
      this.overwritable = this.$store.state.showstoppers[this.errorKey].overwritable;
      this.overwritableReason = this.$store.state.showstoppers[
        this.errorKey
      ].overwritableReason;
      this.overwritableDate = this.$store.state.showstoppers[this.errorKey].overwritableDate;
      this.overwritableUser = this.$store.state.showstoppers[this.errorKey].overwritableUser;
      if (this.overwritableReason.length > 0) {
        this.overwritten = true;
      } else if (!this.val || this.val === '0') {
        this.$store.state.showstoppersErrors[this.errorKey] = this.fallback;
      }
    } else if (this.errorKey && (!this.val || this.val === '0')) {
      this.$store.state.showstoppersErrors[this.errorKey] = this.fallback;
    }
  },
  updated() {
    // eslint-disable-next-line
    this.$store.state.overview[this.$.uid] = (!this.val || this.val === '0') ? false : true;
    if (this.val) {
      delete this.$store.state.errors[this.$.uid];
    }
    if (this.errorKey) {
      if ((this.val && this.val !== '0') || this.overwritableReason.length > 0) {
        delete this.$store.state.showstoppersErrors[this.errorKey];
      } else {
        this.$store.state.showstoppersErrors[this.errorKey] = this.fallback;
      }
    }
  },
  unmounted() {
    // eslint-disable-next-line
    delete this.$store.state.overview[this.$.uid];
    if (!this.val || this.val === '0') {
      // eslint-disable-next-line
      delete this.$store.state.errors[this.$.uid];
    }
    if (this.errorKey) {
      delete this.$store.state.showstoppersErrors[this.errorKey];
    }
  },
  methods: {
    setOverwrite() {
      if (this.overwritableReason.length > 0) {
        this.$store.state.showstoppers[this.errorKey] = {
          error: this.fallback,
          type: this.errorType,
          overwritable: this.overwritable,
          overwritableReason: this.overwritableReason,
          overwritableDate: new Date().toString(),
          overwritableUser: this.$store.state.name,
        };
        if (this.$store.state.showstoppersErrors[this.errorKey]) {
          delete this.$store.state.showstoppersErrors[this.errorKey];
        }
        this.overwritten = true;
      } else {
        delete this.$store.state.showstoppers[this.errorKey];
        this.overwritten = false;
        this.$store.state.showstoppersErrors[this.errorKey] = this.fallback;
      }
    },
    getErrorTypeStyle() {
      if (this.errorType === 'warning') {
        return 'warning';
      }
      if (this.errorType === 'blocker') {
        return 'blocker';
      }
      return 'invalid';
    },
    getErrorTypeIcon() {
      if (!this.val || this.val === '0') {
        if (this.errorType === 'warning') {
          return 'exclamation-circle';
        }
        if (this.errorType === 'showstopper') {
          return 'times';
        }
        return 'ban';
      }
      return 'check';
    },
    inputBasedOnType() {
      if (this.type === 'number') {
        return `${this.formatPrice(Number(this.val), true)}`;
      }
      if (this.type === 'percentage') {
        return `${this.formatPrice(Number(this.val), false, 1)}%`;
      }
      if (this.type === 'money') {
        return `€ ${this.formatPrice(Number(this.val), true)},-`;
      }
      if (this.type === 'year') {
        return `${this.formatPrice(Number(this.val), true)} jaar`;
      }
      return this.val;
    },
  },
};
</script>
